import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** Removes padding. Default padded px-5 py-4. */
  flush?: boolean;
  /** Use --card instead of --panel (one notch up, for inset sections). */
  raised?: boolean;
}

/** A headerless bordered surface: border --line, bg --panel, radius 2px. */
export function Panel({ children, className, flush = false, raised = false, ...rest }: PanelProps) {
  return (
    <div
      className={cn(
        'min-w-0 rounded-sm border border-line',
        raised ? 'bg-card' : 'bg-panel',
        flush ? '' : 'px-5 py-4',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
